'use client';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useJoeLink } from '../../shared/useJoeLink';

export const JoeLink = () => {
  const { href, label } = useJoeLink();
  return (
    <SlotEquivalentLinksItem href={href}>
      <span className="icon-emp-joe size-4" aria-hidden />
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
